
export default {
	GET_VERSION: function(state, payload){
		state.version = payload;
		state.loading = true;
		state.lastCall = undefined;
		state.error = undefined;
	},
	SET_VERSION: function(state, payload){
		state.loading = false;
		state.lastCall = payload;
		state.error = null;
	},
	SET_VERSION_ERROR: function(state, payload){
		state.loading = false;
		state.lastCall = null;
		state.error = payload;
	},
}